import { useRef } from 'react';
import { getAllProductTypes } from '@hooks/useProductTypeHelpers';

export default function useProductTypeLabels(productTypes) {
  const labels = useRef(createProductLabels(productTypes));
  return labels;
}

function createProductLabels(productTypes) {
  const labels = {};

  getAllProductTypes(productTypes).forEach(
    ({ productTypeID, name, changeFrequencyUnits }) => {
      if (productTypeID > 0) {
        labels[String(productTypeID)] = { name, changeFrequencyUnits };
      }
    }
  );

  return labels;
}
